import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";

import makeStyles from "@mui/styles/makeStyles";

import styles from "assets/jss/default/layouts/authStyle.js";
import Login from "pages/login";
import Footer from "components/Footer/Footer";
import { useHistory, useLocation } from "react-router";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { useTrackEvent } from "hooks/useTrackEvent";

const useStyles = makeStyles(styles);

function AuthLayout() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const trackUserEvent = useTrackEvent();

  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  useEffect(() => {
    const urlQueryStr = new URLSearchParams(location.search);
    let shouldClearQueryString = false;
    if (urlQueryStr.has("session_expired")) {
      trackUserEvent("auth-event", "session_expired");
      addSnackbarToQueue({
        message: "Your session has expired. Please login again.",
        severity: "info"
      });
      shouldClearQueryString = true;
    } else if (urlQueryStr.has("logged_out")) {
      trackUserEvent("auth-event", "logged_out");
      addSnackbarToQueue({
        message: "You have been successfully logged out.",
        severity: "success"
      });
      shouldClearQueryString = true;
    }

    if (shouldClearQueryString) {
      if (urlQueryStr.has("return_uri")) {
        history.replace(
          `${location.pathname}?return_uri=${encodeURIComponent(
            urlQueryStr.get("return_uri")
          )}`
        );
      } else {
        history.replace(location.pathname);
      }
    }
  }, [addSnackbarToQueue, history, location, trackUserEvent]);

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.fullPage} ${classes.background}`}>
        <Login />
        <Footer white />
      </div>
    </div>
  );
}

AuthLayout.propTypes = {
  useRedirect: PropTypes.bool,
  authStartCbParams: PropTypes.object
};

export default AuthLayout;
